export default "__VITE_ASSET__8d594953__"